export default __webpack_public_path__ + "static/media/empty.7480c7fb.jpg";